import React from "react";

export function ButtonCustom(props) {
  const {
    label,
    name,
    onClick,
    containerClassName = "",
    width = "auto",
    height = "2.5rem",
    backgroundColor = "#5A3EFF",
    textColor = "#FFFFFF",
    svgIcon = null,
    showIcon = true,
    iconPosition = "left",
    borderRadius = "0.5rem",
    fontSize = "1rem",
    fontWeight = "500",
    border = "none",
  } = props;

  return (
    <button
      type="button"
      name={name}
      onClick={onClick}
      className={containerClassName}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.5rem",
        backgroundColor,
        color: textColor,
        width,
        height,
        borderRadius,
        fontSize,
        fontWeight,
        padding: "0 1rem",
        border,
        cursor: "pointer",
      }}>
      {showIcon && iconPosition === "left" && svgIcon}
      {label}
      {showIcon && iconPosition === "right" && svgIcon}
    </button>
  );
}
